import translations from '../../../../public/data/translations.json'

export const getUrlValues = (query) => {
	const values = {
		page: query?.page || 1,
	};

	if (query.width) values.width = query.width
	if (query.height) values.height = query.height
	if (query.diameter) values.diameter = query.diameter
	if (query.season) values.season = query.season
	if (query.tire_vehicle_type) values.tire_vehicle_type = query.tire_vehicle_type
	if (query.manufacturer) values.manufacturer = query.manufacturer
	if (query.sortBy) values.sortBy = query.sortBy

	return values
}

export const getUrl = (values, locale = 'ME') => {
	const queryString = new URLSearchParams(values).toString()

	const asUrl = `/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}/${translations.pretraga[locale]}?${queryString}`

	const href = {
		pathname: '/vehiclePartsSearch',
		query: {
			...values
		}
	}

	href.query.group = 'gume'

	return { asUrl, href }
}
